export enum GEEleType {
    NodeAddress,
    NodeTransaction,
    EdgeAddressTransactions,
    EdgeTransactionsAddress,
    NodeMerge,
    EdgeMerge,
}